import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { API } from '../App';
import { useT } from '../i18n';
import { Button } from './ui/button';

/*
  Member access: "SSO only" for a member (PATCH /api/admin/users/{id}/sso).
  The server checks the caller is an admin of a shared workspace, never lets an
  admin pin the owner or another admin, and refuses the caller's own account.
*/
export default function MemberSsoControl({ member }) {
  const { t } = useT();
  const [busy, setBusy] = useState(false);
  const [state, setState] = useState(null);
  const userId = member && member.member_user_id;
  if (!userId || member.status !== 'active') return null;

  const set = async (required) => {
    setBusy(true);
    try {
      const r = await axios.patch(API + '/admin/users/' + userId + '/sso', { sso_required: required });
      const now = r.data && typeof r.data.sso_required === 'boolean' ? r.data.sso_required : required;
      setState(now);
      toast.success(now ? t('This member can now sign in only through SSO') : t('This member can sign in with a password again'));
    } catch (e) {
      toast.error((e && e.response && e.response.data && e.response.data.detail) || t('Could not change the sign-in method'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="member-sso">
      <span className="text-xs text-muted-foreground">{t('Sign-in:')}</span>
      <Button size="sm" variant={state === true ? 'default' : 'outline'} disabled={busy} onClick={() => set(true)} data-testid="member-sso-on">
        {t('SSO only')}
      </Button>
      <Button size="sm" variant={state === false ? 'default' : 'outline'} disabled={busy} onClick={() => set(false)} data-testid="member-sso-off">
        {t('Password or SSO')}
      </Button>
    </div>
  );
}
